module.exports = __webpack_public_path__ + "static/media/the_studio.beefe842.svg";